import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withRouter  } from 'react-router';
import moment from 'moment';
import DataGrid from '../components/datagrid/DataGrid';
import { GLO_ORDER } from '../utils/link';
import { TrackingCtx  } from "../tracking";

const badgeConf = {
  'COMPLETED': 'success',
  'NEEDS_UPDATE': 'warn',
  'UPDATED': 'success',
  'ERROR': 'error',
  'NOT AD MANAGER': 'warn'
};

const columns = [
  { id: 'agencyOrderId', label: 'Agency Order ID', link: GLO_ORDER, filterable: true },
  { id: 'agencyOrderName', label: 'Agency Order Name', link: GLO_ORDER, filterable: true, long: true },
  { id: 'opportunityId', label: 'Opportunity Id', filterable: true },
  { id: 'opportunityName', label: 'Opportunity Name', filterable: true },
  { id: 'ioStatus', label: 'Status', filterable: true },
  { id: 'pushStatus', label: 'Push Status', filterable: true, badge: badgeConf },
  { id: 'plCount', label: 'Placements', numeric: true },
  { id: 'totalAmount', label: 'Total Contracted Amount', numeric: true, currency: 'USD' },
  { id: 'start', label: 'Start', date: 'MM/DD/YYYY' },
  { id: 'end', label: 'End', date: 'MM/DD/YYYY' },
  { id: 'changedAt', label: 'Updated', date: 'timeago' }
];

class OrdersGrid extends Component {
  onAdd = () => {
    const { history, match } = this.props;
    const { id } = match.params;
    history.push(`/advertiser/${id}/ios/create`);
  };

  getStatus = (orders) => {
    // status list is here because we don't have constants yet
    const ioStatuses = ['Draft', 'RFP/Proposal', 'LOI', 'Written Agreement', 'Signed IO'];
    return orders.map(o => {
      const locked = this.props.locked && this.props.locked[o.id];
      o.ioStatus = ioStatuses[o.IoStatusId - 1];
      o.locked = locked ? moment(this.props.locked[o.id]).fromNow() : '--';
      return o;
    });
  };

  render() {
    return (
      <TrackingCtx.Consumer>
      {tracking => (
      <TrackingCtx.Provider value={{...tracking, action:"Orders Grid"}}>
      <DataGrid
        columns={columns}
        sortColumn="changedAt"
        sortDirection="desc"
        data={this.getStatus(this.props.orders)}
        title="Orders"
        sortable
        filterable
        pagination
        showFilterRow
        selectable
        onAdd={this.onAdd}
        offsetTop={250}
        showSelectedAmount
        selectedAmount={this.props.selectedAmount}
        onSelect={this.props.onSelect}
        isReadOnly={this.props.isReadOnly}
      />
      </TrackingCtx.Provider>
      )}
      </TrackingCtx.Consumer>
    )
  }
}

OrdersGrid.propTypes = {
  orders: PropTypes.array.isRequired,
  selectedAmount: PropTypes.number
};

export default withRouter(OrdersGrid);
